import { TextInput } from "../../../../components/modals/form-modal/inputs/text-input/text-input.component";
import { IForm } from "../../../../components/modals/form-modal/form-modal.types";
import { Datepicker } from "../../../../components/form-controls/date-picker/date-picker.component";
import { SideBySide } from "../../../../components/side-by-side/side-by-side.component";

export const FlyerCreateForm = (props: IForm) => (
  <>
    <TextInput form={props.form} label="Design Layout Name" name="name" required />
    <SideBySide>
      <Datepicker form={props.form} label="Start Date" name="startAt" required />
      <Datepicker form={props.form} label="End Date" name="endAt" required />
    </SideBySide>
    <SideBySide>
      <Datepicker
        form={props.form}
        label="First Review: Ad Planner Updates to be Completed"
        name="wtwReviewDate"
        required
      />
      <Datepicker
        form={props.form}
        label="Sr. Review: Ad Planner Updates to be Completed"
        name="wtwSeniorReviewDate"
        required
      />
    </SideBySide>
  </>
);
